/**
 * PURPOSE: Consumir endpoints administrativos de publicaciones individuales desde Winscore.
 * RESPONSIBILITIES: Listar, crear PDF/enlace y eliminar lógicamente publicaciones de programación o resultados.
 * COLLABORATORS: SportIndividualArea.jsx, API_BASE_URL y backend/routes/auxiliar/DocumentosPDFRoute.js.
 * ROUTE: winscore/src/services/individualDocumentService.js
 */
import axios from "axios";
import API_BASE_URL from "../config/config.js";

const unwrap = (response) => response.data?.data || response.data;

export const listIndividualDocuments = async ({ idevent, idsport }) => {
  const response = await axios.post(`${API_BASE_URL}/getdocumentospdf`, {
    idevent: Number(idevent),
    idsport: Number(idsport),
  });

  const payload = unwrap(response);
  return Array.isArray(payload) ? payload : [];
};

export const createIndividualDocument = async ({
  idevent,
  idsport,
  publicationType,
  source,
  title,
  file,
  url,
}) => {
  const formData = new FormData();
  formData.append("idevent", String(Number(idevent)));
  formData.append("idsport", String(Number(idsport)));
  formData.append("tipo", String(Number(publicationType)));
  formData.append("source", source);
  formData.append("title", title || "");

  if (source === "pdf" && file) {
    formData.append("file", file);
  }

  if (source === "link") {
    formData.append("url", url || "");
  }

  const response = await axios.post(`${API_BASE_URL}/createindividualdocument`, formData);
  return unwrap(response);
};

export const deleteIndividualDocument = async ({ iddoc }) => {
  const response = await axios.post(`${API_BASE_URL}/editstatedocumentopdf`, {
    iddoc: Number(iddoc),
  });

  return unwrap(response);
};
